<template>
  <v-dialog v-model="show" persistent max-width="760">
    <v-card
      width="760"
      style="padding: 24px; border-radius: 5px !important;">
      <div
        class="d-flex justify-space-between">
        <span
          :class="`${defaultColor}--text font-weight-bold`"
          style="font-weight: 18px;">
          Exportar Relatório
        </span>

        <v-icon @click="hideModal()">
          mdi-close
        </v-icon>
      </div>

      <div
        class="d-flex justify-center align-center flex-column"
        style="padding-top: 24px;">
        <v-icon
          color="success"
          size="24">
          mdi mdi-check-circle-outline
        </v-icon>

        <span
          class="font-weight-bold foreground--text"
          style="font-weight: 16px; padding-top: 8px;">
          Relatório solicitado com sucesso!
        </span>
      </div>

      <div
        style="padding-top: 35px;">
        <v-alert
          color="scroll-background mb-0"
          class="info--text">
          <v-row no-gutters>
            <v-col
              cols="12">
              <p class="font-weight-bold text-body-2">
                Trouxemos uma nova experiência para a emissão de relatórios de posição cadastral!
              </p>
              <p
                class="mb-0 pb-0 text-body-2">
                • Seus relatórios agora ficam na aba
                <span class="font-weight-bold">"Meus Relatórios"</span>;
              </p>
              <p
                class="mb-0 pb-0 text-body-2">
                • O histórico das suas emissões estará sempre disponível para consulta e download.
              </p>
            </v-col>
          </v-row>
        </v-alert>
      </div>

      <div
        class="d-flex justify-end"
        style="padding-top: 30px;">
        <v-btn
          class="mr-2"
          outlined
          :color="defaultColor"
          style="height: 50px; width: 160px; border-radius: 10px;"
          @click="hideModal()">
          Cancelar
        </v-btn>

        <v-btn
          class="ml-2"
          :color="defaultColor"
          style="height: 50px; width: 300px; border-radius: 10px;"
          @click="goToTab">
          Ir para Emissão de Relatórios
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ExportConfirmModal",

  data: () => ({
    show: false,
  }),

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    defaultColor: {
      type: String,
      default: 'primary'
    },
  },

  watch: {
    showModal: {
      handler(show) {
        this.show = show;
      }
    }
  },

  methods: {
    goToTab() {
      this.hideModal();
      this.$emit('goToTab');
    },

    hideModal() {
      this.$emit('hideModal')
    }
  }
}
</script>